import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {BusinessService} from '../../../../common/services/Business.service';
import {SettingService} from '../../../../common/services/Setting.service';
import {UploadService} from '../../../../common/services/Upload.service';
import {Location} from '@angular/common';
import {EvsAddressService} from '../../../../common/services/EvsAddress.service';
import {ToastrService} from 'ngx-toastr';

declare var $: any;

@Component({
  selector: 'app-setting-sale-bussiness',
  templateUrl: 'setting-sale-bussiness.templete.html',
  styleUrls: ['./business.css'],
  providers: [BusinessService, EvsAddressService, UploadService, SettingService],
})
export class SettingSaleBussinessComponent implements OnInit {
  @Input('dataBusiness') dataBusiness: any;
  @Output('backToList') backToList = new EventEmitter();
  public data: any;

  constructor(
    private _fb: FormBuilder,
    private businessService: BusinessService,
    private addressService: EvsAddressService,
    private settingService: SettingService,
    private upload: UploadService,
    private _location: Location,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit() {
    this.data = {...this.dataBusiness}
  }

  goBack() {
    this.backToList.emit({
      isBack: true,
    });
  }

  submitFormBussiness() {
    const type = []
    if (this.data.pp == true) {
      type.push(1)
    }
    if (this.data.sms == true) {
      type.push(3)
    }
    if (this.data.loyalty == true) {
      type.push(2)
    }
    const body = {
      'settingType': 1,
      'type': type
    }
    this.settingService.updateSettingConfig(body).subscribe((res: any) => {
      console.log('res', res)
      if (res.code == 1) {
        console.log('resssssss', res.code)
        this.toastr.success('Thành công', 'Thông báo', {
          timeOut: 4000, positionClass: 'toast-bottom-right'
        })
      }
    }, (err: any) => {
      this.toastr.success(err, 'Thông báo', {
        timeOut: 4000, positionClass: 'toast-bottom-right'
      })
    })
    setTimeout(() => {
      this.goBack()
    }, 100)
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-sale-bussiness.component.ts